webpackJsonp([13],{

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalWork_vue__ = __webpack_require__(381);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6ae92b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalWork_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6ae92b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalWork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6ae92b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalWork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
module.exports = __webpack_require__(3).Object.assign;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(183) });


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(65);
var IObject = __webpack_require__(64);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_AdditionalWorkService__ = __webpack_require__(484);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      /****************\
      **Visual/Dialogs**
      \****************/
      loading: false,
      /* Alerta */
      alertType: "info",
      alertColor: "",
      alert: false,
      alertMessage: [],
      alertForm: false,
      alertMessageForm: [],
      /* Dialogs */
      dialog: false,
      dialogRemove: false,
      dialogDetails: false
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "loading", true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "search", ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "loadingRecordsText", "Carregando Registros..."), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "emptyRecordsText", "Nenhum registro foi encontrado."), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "emptySearchText", "Nenhum registro encontrado para"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDetailsTitle", "Detalhes do Adicional de Trabalho"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "dialogEditingTitle", "Alterar Adicional de Trabalho"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "dialogCreatingTitle", "Cadastrar Adicional de Trabalho"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "emptyRecordsText", "Nenhum Registro Encontrado"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "footerTotalRecordsText", "Total de Registros"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "footerLoadingRecordsText", "Carregando"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "title", "Listagem de Adicionais de Trabalho"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "additionals", []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "additional", {
      value: 0
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "records", 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [{
      text: "Descrição",
      align: "center",
      value: "description"
    }, {
      text: "Valor (R$)",
      align: "center",
      value: "value"
    }, {
      text: "Situação",
      align: "center",
      value: "active"
    }, {
      text: "",
      align: "center",
      value: "active",
      sortable: false
    }]), _ref;
  },

  created: function created() {
    this.initialize();
  },


  watch: {
    dialog: function dialog(val) {
      val || this.initialize();
    },
    dialogDetails: function dialogDetails(val) {
      val || this.initialize();
    }
  }, //watch

  computed: {
    dynamicFooterText: function dynamicFooterText() {
      var text = (this.records > 0 ? this.footerTotalRecordsText : this.emptyRecordsText) + " : " + this.records + " ";
      return "" + (this.loading ? '' : text);
    },
    dynamicNoDataText: function dynamicNoDataText() {
      var text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    },
    dynamicDialogTitle: function dynamicDialogTitle() {
      var text = this.additional._id ? this.dialogEditingTitle : this.dialogCreatingTitle;
      return text;
    }
  },

  methods: {
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this.getAll();

              case 4:
                _this.additional = {};
                _this.dialog = false;
                _this.calculateRecords();
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                _this.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9, 12, 15]]);
      }))();
    },


    /*********************\
    **Visual/Estatisticas**
    \*********************/

    actionNewButton: function actionNewButton() {
      this.resetAlert();
      this.additional = {};
    },


    /* Estatisticas */

    calculateRecords: function calculateRecords() {
      var amount = 0;
      for (var i = 0; i < this.additionals.length; i++) {
        amount++;
      }
      this.records = amount;
    },
    validateFields: function validateFields() {
      if (!this.additional || !this.additional.description) {
        this.showAlert('form', "Descrição deve ser informada", "error", "error");
      }

      return this.alertMessageForm.length == 0 ? true : false;
    },


    /* Dialogs */

    detailAdditional: function detailAdditional(item) {
      this.additional = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialogDetails = true;
    },
    closeDialog: function closeDialog(dialog) {
      this.loading = true;
      try {
        this.additional = new Object();
        switch (dialog) {
          case 'modal':
            this.dialog = false;
            break;

          case 'details':
            this.dialogDetails = false;
            break;

          case 'remove':
            this.dialogRemove = false;
            break;

          default:
            this.dialog = false;
            this.dialogRemove = false;
            this.dialogDetails = false;
            break;
        }
      } catch (error) {
        console.log("Erro ao fechar dialog : " + new Error(error));
      } finally {
        this.loading = false;
      }
    },


    /* Alert */

    resetAlert: function resetAlert() {
      this.alertMessage = "";
      this.alertMessageForm = [];
      this.alertType = "info";
      this.alertColor = "";
      this.alert = false;
    },
    showAlert: function showAlert(place, msg, color, type, timeout) {
      var _this2 = this;

      if (this.alert == true) this.resetAlert();
      if (msg != "" || undefined || null) place == 'form' ? this.alertMessageForm.push(msg) : this.alertMessage = msg;
      if (type != "" || undefined || null && !color) this.alertType = type;else if (color != "" || undefined || null && !type) this.alertColor = color, this.alertType = "";else if (!type && !color) this.alertType = "info";
      place == 'form' ? this.alertForm = true : this.alert = true;
      if (timeout != undefined || null) {
        var _t = Math.min(timeout, 10000);
        var _timeout = Math.max(timeout, 1000);
        if (_timeout) {
          setTimeout(function () {
            if (!_this2.alert) return;
            if (_this2.alertMessage == msg) _this2.resetAlert();
          }, _timeout || 5000);
        }
      };
    },


    /*********\
    **Getters**
    \*********/

    getAll: function getAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__service_AdditionalWorkService__["a" /* default */].getAll();

              case 4:
                _this3.additionals = _context2.sent;
                _context2.next = 12;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);

                _this3.showAlert('a', "Ocorreu um erro ao tentar listar os Adicionais de Trabalho cadastrados. Por favor contate o suporte técnico.", "error", "error");
                console.log(_context2.t0.message);
                return _context2.abrupt("return");

              case 12:
                _context2.prev = 12;

                _this3.loading = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 7, 12, 15]]);
      }))();
    },


    /******\
    **CRUD**
    \******/

    edit: function edit(item) {
      this.resetAlert();
      this.additional = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.resetAlert();

                if (_this4.validateFields()) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", _this4.alertForm = true);

              case 3:
                if (!_this4.additional._id) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 4;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__service_AdditionalWorkService__["a" /* default */].edit(_this4.additional);

              case 7:
                _this4.showAlert('a', "Adicional de Trabalho alterado com sucesso", "success", "success");
                _context3.next = 16;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](4);

                _this4.showAlert('a', "Ocorreu um erro ao tentar alterar o Adicional de Trabalho. Por favor contate o suporte técnico.", "error", "error");
                _this4.initialize();
                console.log(_context3.t0.message);
                return _context3.abrupt("return");

              case 16:
                _context3.next = 30;
                break;

              case 18:
                _context3.prev = 18;
                _context3.next = 21;
                return __WEBPACK_IMPORTED_MODULE_4__service_AdditionalWorkService__["a" /* default */].save(_this4.additional);

              case 21:
                _this4.showAlert('a', "Adicional de Trabalho criado com sucesso", "success");
                _context3.next = 30;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t1 = _context3["catch"](18);

                _this4.showAlert('a', "Ocorreu um erro ao tentar criar o Adicional de Trabalho. Por favor contate o suporte técnico.", "error");
                _this4.initialize();
                console.log(_context3.t1.message);
                return _context3.abrupt("return");

              case 30:

                _this4.dialog = false;

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[4, 10], [18, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(483);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("00a3c01b", content, true, {});

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, ".actions-padding[data-v-f6ae92b4]{padding-bottom:19px;padding-left:18px;padding-right:18px}.pt-switch[data-v-f6ae92b4]{padding-top:20px}", "", {"version":3,"sources":["/vercel/path0/src/pages/AdditionalWork.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4BACE,gBAAkB,CACnB","file":"AdditionalWork.vue","sourcesContent":["\n.actions-padding[data-v-f6ae92b4] {\n  padding-bottom: 19px;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n.pt-switch[data-v-f6ae92b4] {\n  padding-top: 20px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var additionalService = function () {
  function additionalService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, additionalService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(additionalService, null, [{
    key: "getAll",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var additional;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "additionals_work");

              case 3:
                additional = _context.sent;
                return _context.abrupt("return", additional.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new Error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll();

  }, {
    key: "save",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(additional) {
        var additionalSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "additionals_work", additional);

              case 3:
                additionalSaved = _context2.sent;
                return _context2.abrupt("return", additionalSaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                throw new Error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: "edit",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(additional) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "additionals_work", additional);

              case 3:
                _context3.next = 8;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3["catch"](0);
                throw new Error(_context3.t0);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 5]]);
      }));

      function edit(_x2) {
        return _ref3.apply(this, arguments);
      }

      return edit;
    }() // edit()

  }, {
    key: "remove",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(additional) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "additionals_work", {
                  data: additional
                });

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);
                throw new Error(_context4.t0);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref4.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return additionalService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (additionalService);

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"transition":"slide-y-transition"},on:{"click":function($event){return _vm.resetAlert();}}},[_c('v-alert',{attrs:{"transition":"slide-y-transition","dismissible":"","outline":"","color":_vm.alertColor,"type":_vm.alertType},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n      "+_vm._s(_vm.alertMessage)+"\n    ")])],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","transition":"slide-y-reverse-transition"}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"900px","persistent":"","loading":_vm.loading},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.loading,"loading":_vm.loading,"color":"info","icon":"","round":""},on:{"click":function($event){return _vm.actionNewButton();}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1 font-weight-light",attrs:{"color":"white","card":""}},[_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v("\n            "+_vm._s(_vm.dynamicDialogTitle)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-switch',{staticClass:"pt-switch",attrs:{"disabled":_vm.loading,"label":_vm.additional.active ? "Ativa" : "Inativa"},model:{value:(_vm.additional.active),callback:function ($$v) {_vm.$set(_vm.additional, "active", $$v)},expression:"additional.active"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){return _vm.closeDialog('modal')}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"pa-4":"","ma-4":"","pt-5":""},on:{"click":function($event){_vm.additional = {}}}},[_c('v-alert',{attrs:{"pa-4":"","ma-4":"","pt-5":"","transition":"slide-x-reverse-transition","dismissible":"","type":_vm.alertType},model:{value:(_vm.alertForm),callback:function ($$v) {_vm.alertForm=$$v},expression:"alertForm"}},_vm._l((_vm.alertMessageForm),function(msg){return _c('span',{key:msg},[_vm._v(_vm._s(msg)+" "),_c('br')])}),0)],1),_vm._v(" "),_c('v-card-text',{attrs:{"transition":"fade-transition"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"box":"","label":"Valor * (R$)","type":"number"},model:{value:(_vm.additional.value),callback:function ($$v) {_vm.$set(_vm.additional, "value", $$v)},expression:"additional.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"box":"","label":"Descrição *","autofocus":""},model:{value:(_vm.additional.description),callback:function ($$v) {_vm.$set(_vm.additional, "description", $$v)},expression:"additional.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"no-resize":"","label":"Observações","value":_vm.additional.observation,"rows":"5","box":""}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-footer',{staticClass:"white--text pa-3 mb-3 mx-3 elevation-1",staticStyle:{"border-radius":"5px"},attrs:{"height":"auto","width":"100%","color":"info"}},[_c('span',[_vm._v("\n            Os campos marcados com o (*) são obrigatórios\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card-actions',{staticClass:"actions-padding"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"color":"success lighten-1","block":"","round":"","loading":_vm.loading,"large":""},on:{"click":function($event){return _vm.save();}}},[_vm._v("Salvar")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"rows-per-page-text":"Colunas por página","transition":"slide-y-reverse-transition","search":_vm.search,"headers":_vm.headers,"items":_vm.additionals,"loading":_vm.loading},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")(props.item.value)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"small":"","color":props.item.active == false ? 'error' : 'success lighten-1',"disabled":props.item.active == false}},[_vm._v(_vm._s(props.item.active == false ? 'Inativa' : 'Ativa'))])],1),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","icon":"","round":"","title":"Editar"}},[_c('v-icon',{attrs:{"color":"info"},on:{"click":function($event){return _vm.edit(props.item);}}},[_vm._v("\n            edit\n          ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","icon":"","round":"","title":"Detalhes"}},[_c('v-icon',{attrs:{"color":"info"},on:{"click":function($event){return _vm.detailAdditional(props.item);}}},[_vm._v("\n            info\n          ")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      Linhas "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),_c('div',{attrs:{"slot":"no-results","value":true},slot:"no-results"},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.emptySearchText)+" \""+_vm._s(_vm.search)+"\".")])]),_vm._v(" "),(_vm.records > 0)?_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"100%"}},[_c('strong',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.dynamicFooterText))])])]):_c('template',{slot:"no-data"},[_c('strong',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.dynamicNoDataText)+" ")])])],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"900px","loading":_vm.loading},model:{value:(_vm.dialogDetails),callback:function ($$v) {_vm.dialogDetails=$$v},expression:"dialogDetails"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":"","color":"white"}},[_c('v-toolbar-title',{staticClass:"headline font-weight-light"},[_vm._v("\n          "+_vm._s(_vm.dialogDetailsTitle)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error lighten-1","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closeDialog('details')}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[(_vm.additional)?_c('v-layout',{staticClass:"font-weight-light",attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('span',{staticClass:"headline font-weight-light",attrs:{"ml-2":"","pl-2":""}},[_vm._v("Situação: "),_c('span',{class:_vm.additional.active ? 'green--text font-weight-light' : 'red--text font-weight-light'},[_vm._v(_vm._s(_vm.additional.active ? "Ativo" : "Inativo"))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","mb-1":""}},[_c('v-text-field',{attrs:{"label":"Base do Cálculo","readonly":"","box":""},model:{value:(_vm.additional.calculationBase),callback:function ($$v) {_vm.$set(_vm.additional, "calculationBase", $$v)},expression:"additional.calculationBase"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","mb-1":""}},[_c('v-text-field',{attrs:{"label":"Percentual","readonly":"","box":""},model:{value:(_vm.additional.percentual),callback:function ($$v) {_vm.$set(_vm.additional, "percentual", $$v)},expression:"additional.percentual"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[_c('v-text-field',{attrs:{"label":"Descrição","box":"","readonly":""},model:{value:(_vm.additional.description),callback:function ($$v) {_vm.$set(_vm.additional, "description", $$v)},expression:"additional.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[_c('v-textarea',{attrs:{"label":"Observação","readonly":"","box":""},model:{value:(_vm.additional.observation),callback:function ($$v) {_vm.$set(_vm.additional, "observation", $$v)},expression:"additional.observation"}})],1)],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.0bb694413a8a7c84f867.js